import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Home } from '@/components/pages/Home';
import { About } from '@/components/pages/About';
import { Blog } from '@/components/pages/Blog';
import { ProductPreList } from '@/components/pages/ProductPreList';
import { Booking } from '@/components/pages/Booking';
import { NewProductDetails } from '@/components/pages/NewProductDetails';
import { NewProductDetails as NewProductDetails2ndVersion } from '@/components/pages/NewProductDetails2ndVersion';
import { NotFound } from '@/components/pages/NotFound';
import { Checkout } from '@/components/pages/Checkout';
import { Search } from '@/components/pages/Search';
import { BlogDetails } from '@/components/pages/BlogDetails';
import { ReservationSuccess } from '@/components/pages/ReservationSuccess';
import { NewReservationSuccess } from '@/components/pages/NewReservationSuccess';
import { TermsAndConditions } from '@/components/pages/TermsAndConditions';
import { TermsAndConditionsGuest } from '@/components/pages/TermsAndConditionsGuest';
import { TermsAndConditionsPromo } from '@/components/pages/TermsAndConditionsPromo';
import { CancelationPolicies } from '@/components/pages/CancelationPolicies';
import { WorkspaceMap } from '@/components/pages/WorkspaceMap';
import { PromoLanding } from '@/components/pages/PromoLanding';
import { ProductDetailsLandingPage } from '@/components/pages/ProductDetailsLandingPage';
import { PrivacyPolicy } from '@/components/pages/PrivacyPolicy';
import CreacionSpace from '@/components/pages/Home/CreacionSpace';
import CreacionUser from '@/components/pages/Home/CreacionUser';
import CreacionBlogs from '@/components/pages/Home/CreacionBlogs';
import Login from '@/components/pages/Login';
import Locations from '@/components/pages/Locations';
import Signup from '@/components/pages/Signup';
import { SpacesDetails } from '@/components/pages/SpacesDetails';
import GuestInfo from '@/components/pages/GuestInfo';
import GuestSelected from '@/components/pages/GuestSelected';
import Workspaces from '@/components/pages/Workspaces';
import TimeError from '@/components/pages/TimeError';
import ReservationDate from '@/components/pages/ReservationDate';
import ReservationTime from '@/components/pages/ReservationTime';
import PaymentCard from '@/components/pages/PaymentCard';
import PaymentCardSelector from '@/components/pages/PaymentCardSelector';
import PaymentData from '@/components/pages/PaymentData';
import BookingSuccess from '@/components/pages/BookingSuccess';
import BookingConfirmation from '@/components/pages/BookingConfirmation';
import StillBuilding from '@/components/pages/StillBuilding';

const AppRoutes = () => {
  const location = useLocation();
  const componentKey = location.pathname;
  return (
    <Routes>
      {/*<Route path="/" element={<Home key={location.key} />} />*/}
      <Route path="/" element={<WorkspaceMap key={location.key} />} />
      <Route path="/inicio" element={<WorkspaceMap key={location.key} />} />
      <Route path="/home" element={<WorkspaceMap key={location.key} />} />
      <Route path="/spaces" element={<About />} />
      <Route path="/espacios" element={<About />} />

      <Route path="/blog" element={<Blog />} />
      <Route path="/blog-popnest" element={<Blog />} />

      <Route path="/login" element={<Login />} />
      <Route path="/iniciar-sesion" element={<Login />} />

      <Route
        path="/detalle-espacio/:customText/:idSubSpace"
        element={<SpacesDetails />}
      />

      <Route
        path="/detalle-espacio/:customText/:idSubSpace/:modalOpen"
        element={<SpacesDetails />}
      />

      <Route
        path="/space-detail/:customText/:idSubSpace"
        element={<SpacesDetails />}
      />

      <Route
        path="/space-detail/:customText/:idSubSpace/:modalOpen"
        element={<SpacesDetails />}
      />

      <Route path="/space-detail/:customText" element={<SpacesDetails />} />
      <Route path="/space-detail/:customText" element={<SpacesDetails />} />

      <Route path="/signup" element={<Signup />} />
      <Route path="/registrarse" element={<Signup />} />

      <Route path="/signup/:email" element={<Signup />} />
      <Route path="/registrarse/:email" element={<Signup />} />

      <Route path="/locations" element={<Locations />} />
      <Route path="/ubicaciones" element={<Locations />} />

      <Route path="/guestinfo" element={<GuestInfo />} />
      <Route path="/info-usuario" element={<GuestInfo />} />

      <Route path="/guestselected" element={<GuestSelected />} />
      <Route path="/seleccion-usuario" element={<GuestSelected />} />

      <Route path="/workspace" element={<Workspaces />} />
      <Route path="/espacio-trabajo" element={<Workspaces />} />

      <Route path="/time-error" element={<TimeError />} />
      <Route path="/error-tiempo" element={<TimeError />} />

      <Route path="/search" element={<Search />} />
      <Route path="/busqueda" element={<Search />} />

      <Route
        path="/reservation-date/:idSubSpace"
        element={<ReservationDate />}
      />
      <Route
        path="/reservacion-fecha/:idSubSpace"
        element={<ReservationDate />}
      />

      <Route
        path="/reservation-time/:idSubSpace"
        element={<ReservationTime />}
      />
      <Route
        path="/reservacion-tiempo/:idSubSpace"
        element={<ReservationTime />}
      />

      <Route path="/reservation-date" element={<ReservationDate />} />
      <Route path="/reservacion-fecha" element={<ReservationDate />} />

      <Route path="/reservation-time" element={<ReservationTime />} />
      <Route path="/reservacion-tiempo" element={<ReservationTime />} />

      <Route path="/payment-data" element={<PaymentData />} />
      <Route path="/datos-pago" element={<PaymentData />} />

      <Route path="/payment-card" element={<PaymentCard />} />
      <Route path="/pago-tarjeta" element={<PaymentCard />} />

      <Route path="/booking-success" element={<BookingSuccess />} />
      <Route path="/pago-tarjeta" element={<BookingSuccess />} />

      <Route path="/booking-confirmation" element={<BookingConfirmation />} />
      <Route path="/reserva-confirmada" element={<BookingConfirmation />} />

      <Route path="/stillbuilding" element={<StillBuilding />} />
      <Route path="/aun-construyendo" element={<StillBuilding />} />

      <Route path="/payment-card-selector" element={<PaymentCardSelector />} />
      <Route path="/seleccion-pago-tarjeta" element={<PaymentCardSelector />} />

      <Route path="/blog-popnest-detalle/:id" element={<BlogDetails />} />
      <Route path="/blog-popnest-detail/:id" element={<BlogDetails />} />

      <Route path="/your-spaces" element={<About />} />
      <Route path="/tu-espacio" element={<About />} />

      <Route path="/promo-landing" element={<PromoLanding />} />
      <Route path="/promo-aterrizaje" element={<PromoLanding />} />

      <Route path="/lista-espacios" element={<ProductPreList />} />
      <Route path="/spaces-list" element={<ProductPreList />} />

      <Route path="/booking" element={<Booking />} />

      <Route path="/confirmar-reservacion" element={<NewProductDetails />} />
      <Route
        path="/confirmar-reservacion/:customText"
        element={<NewProductDetails />}
      />
      <Route
        path="/confirmar-reservacion/:customText"
        element={<NewProductDetails />}
      />
      <Route path="/confirm-reservation" element={<NewProductDetails />} />
      <Route
        path="/confirm-reservation/:customText"
        element={<NewProductDetails />}
      />
      <Route
        path="/confirmar-reservacion/:customText/:idSubSpace"
        element={<NewProductDetails />}
      />
      <Route
        path="/confirm-reservation/:customText/:idSubSpace"
        element={<NewProductDetails />}
      />

      <Route
        path="/confirmar-reservacion2nd"
        element={<NewProductDetails2ndVersion />}
      />
      <Route
        path="/confirmar-reservacion2nd/:customText"
        element={<NewProductDetails2ndVersion />}
      />
      <Route
        path="/confirmar-reservacion2nd/:customText"
        element={<NewProductDetails2ndVersion />}
      />
      <Route
        path="/confirm-reservation2nd"
        element={<NewProductDetails2ndVersion />}
      />
      <Route
        path="/confirm-reservation2nd/:customText"
        element={<NewProductDetails2ndVersion />}
      />
      <Route
        path="/confirmar-reservacion2nd/:customText/:idSubSpace"
        element={<NewProductDetails2ndVersion />}
      />
      <Route
        path="/confirm-reservation2nd/:customText/:idSubSpace"
        element={<NewProductDetails2ndVersion />}
      />
      <Route
        path="/confirmar-reservacion2nd/:customText/:idSubSpace/:modalOpen"
        element={<NewProductDetails2ndVersion key={componentKey} />}
      />
      <Route
        path="/confirm-reservation2nd/:customText/:idSubSpace/:modalOpen"
        element={<NewProductDetails2ndVersion key={componentKey} />}
      />

      <Route path="/reserva-confirmada" element={<ReservationSuccess />} />
      <Route path="/reservation-confirmed" element={<ReservationSuccess />} />

      <Route
        path="/nueva-reserva-confirmada"
        element={<NewReservationSuccess />}
      />
      <Route
        path="/new-reservation-confirmed"
        element={<NewReservationSuccess />}
      />

      <Route path="/pago" element={<Checkout />} />
      <Route path="/pay" element={<Checkout />} />

      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/terminos-condiciones" element={<TermsAndConditions />} />

      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/politica-privacidad" element={<PrivacyPolicy />} />

      <Route
        path="/terms-conditions-guest"
        element={<TermsAndConditionsGuest />}
      />
      <Route
        path="/terminos-condiciones-invitado"
        element={<TermsAndConditionsGuest />}
      />

      <Route
        path="/terminos-condiciones-promocion"
        element={<TermsAndConditionsPromo />}
      />
      <Route
        path="/terms-conditions-promo"
        element={<TermsAndConditionsPromo />}
      />

      <Route path="/privacy-conditions" element={<CancelationPolicies />} />
      <Route path="/condiciones-privacidad" element={<CancelationPolicies />} />

      <Route path="*" element={<NotFound />} />

      <Route path="/creation-user" element={<CreacionUser />} />
      <Route path="/creacion-usuario" element={<CreacionUser />} />

      <Route path="/creation-space" element={<CreacionSpace />} />
      <Route path="/creacion-espacio" element={<CreacionSpace />} />

      <Route path="/creation-blogs" element={<CreacionBlogs />} />
      <Route path="/creacion-blogs" element={<CreacionBlogs />} />

      <Route
        path="/terminos-condiciones-anfitrion"
        element={<TermsAndConditions />}
      />
      <Route
        path="/terms-conditions-guest"
        element={<TermsAndConditionsGuest />}
      />

      <Route
        path="/paseDeCoworkingPolanco"
        element={<ProductDetailsLandingPage language={'ES'} space={7} />}
      />
      <Route
        path="/dayPassCoworkingPolanco"
        element={<ProductDetailsLandingPage language={'EN'} space={7} />}
      />
      <Route
        path="/paseDeCoworkingCondesa"
        element={<ProductDetailsLandingPage language={'ES'} space={55} />}
      />
      <Route
        path="/dayPassCoworkingCondesa"
        element={<ProductDetailsLandingPage language={'EN'} space={55} />}
      />
      <Route
        path="/salaDeJuntasPolanco"
        element={<ProductDetailsLandingPage language={'ES'} space={10} />}
      />
      <Route
        path="/meetingRoomPolanco"
        element={<ProductDetailsLandingPage language={'EN'} space={10} />}
      />
    </Routes>
  );
};

export default AppRoutes;
